import type { ActivityTone } from '../types/activity'

export const activityIconClasses: Record<ActivityTone, string> = {
  brand: 'bg-brand-50 text-brand-700',
  teal: 'bg-teal-50 text-teal-700',
  navy: 'bg-navy-50 text-navy-600',
  warn: 'bg-warn-50 text-warn-700',
  success: 'bg-success-50 text-success-700',
}

export const urgencyRowClasses: Record<
  'urgent' | 'attention' | 'normal',
  string
> = {
  urgent: 'border-danger-200 bg-danger-50/50',
  attention: 'border-warn-200 bg-warn-50/50',
  normal: 'border-navy-100 bg-white',
}
